export default function SVGWrapper({ children, color="var(--theme-main-color)", width, height, viewBox = "0 0 20 10", className }) {
    return <svg xmlns="http://www.w3.org/2000/svg"
        fill={color}
        width={width}
        height={height}
        viewBox={viewBox}
        className={className}>
        {children}
    </svg>
}